import urls from "../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../utils/service";

export async function getAllDepartment() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLDEPARTMENT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllDesignation(departmentId: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLDESIGNATIONBYDEPARTMENTID + departmentId, 
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getTeamByDepartment(departmentId:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETTEAMMETA + `?departmentId=${departmentId}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getProjectsByTeam(teamIds: string[], userId?: string) {
  try {
    const ids = (teamIds || []).filter(Boolean).join(",");
    if (!ids) return { success: 1, data: [] };
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams({ team_id: ids });
    if (userId) qs.set("userId", String(userId));
    return await makeCall(`${urls.GETPROJECTSBYTEAM}?${qs.toString()}`, callParams);
  } catch (error) {
    throw error;
  }
}

export async function assignUserToTeamProjects(payload: {
  userId: string;
  projectIds: string[];
  unassignProjectIds?: string[];
  assign: boolean;
}) {
  try {
    const callParams = await getCallParams("POST", payload);
    return await makeCall(urls.ASSIGNUSERTOTEAMPROJECTS, callParams);
  } catch (error) {
    throw error;
  }
}

export async function getReportingManager(hierarchyId: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLREPORTINGMANAGER + hierarchyId, 
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}